import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="remote-modal"
export default class extends Controller {
  connect() {
    this.modal = new window.bootstrap.Modal(this.element)
  }

  open() {
    this.modal.show()
  }

  close({ detail: { success } }) {
    if (success) {
      this.modal.hide()
    }
  }
}
